import { render, staticRenderFns } from "./markDialog.vue?vue&type=template&id=2ced09ca&scoped=true&"
import script from "./markDialog.vue?vue&type=script&lang=js&"
export * from "./markDialog.vue?vue&type=script&lang=js&"
import style0 from "./markDialog.vue?vue&type=style&index=0&id=2ced09ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced09ca",
  null
  
)

export default component.exports